export default __webpack_public_path__ + "static/media/login.749d3238.svg";